import { render, staticRenderFns } from "./OmzR_Search.vue?vue&type=template&id=22883a21"
import script from "./OmzR_Search.vue?vue&type=script&lang=js"
export * from "./OmzR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports